<template>
  <div class="list_index">
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          class="yl-button"
          @click="handleAdd"
        >新增</el-button>
      </el-col>
    </el-row>

    <el-table
      v-loading="loading"
      :data="deptList"
      row-key="deptId"
      border
      stripe
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
    >
      <el-table-column prop="deptName" align="left" label="部门名称" width="260" show-overflow-tooltip></el-table-column>
      <el-table-column prop="orderNum" align="center" label="排序" width="100"></el-table-column>
      <el-table-column prop="status" align="center" label="状态" width="100">
        <template slot-scope="scope">
          <span>{{scope.row.status == 0?'正常':'停用'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="序列号" align="center" prop="serialNumbers" width="160">
            <template slot-scope="scope">
              <el-button v-if="scope.row.children.length == 0" type="text" @click="showSerialNumber(scope.row)">查看</el-button>
              <el-button v-if="scope.row.children.length == 0" type="text" @click="deitSerialNumberJurisdiction(scope.row)">修改</el-button>
              <p v-else class="text">--</p>
            </template>
          </el-table-column>
      <el-table-column label="创建时间" align="center" prop="createTime" width="260"></el-table-column>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button 
            size="mini" 
            type="text" 
            icon="el-icon-bj" 
            class="item"
            @click="handleUpdate(scope.row)"
          ></el-button>
          <!-- <el-button 
            size="mini" 
            type="text" 
            icon="el-icon-plus" 
            @click="handleAdd(scope.row)"
          >新增</el-button> -->
          <el-button
            size="mini"
            type="text"
            icon="el-icon-sc"
            class="item"
            @click="handleDelete(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加或修改部门对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="40%" append-to-body @close='closeDialog'>
      <el-form ref="form" :model="form" :rules="rules" label-width=".8rem">
        <el-row>
          <el-col :span="14" v-if="form.parentName !== null">
            <el-form-item label="上级部门" prop="parentName">
              <el-select v-model="form.parentName" placeholder="请选择上级部门" class="parentName">
                <el-option v-for="(item,index) in deptList" :key="index" :label="item.deptName" :value="item.deptName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门名称" prop="deptName">
              <el-input v-model="form.deptName" class="yl-input_noIcon" placeholder="请输入部门名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="显示排序" prop="orderNum">
              <el-input-number v-model="form.orderNum" controls-position="right" :min="0" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门状态">
              <el-radio-group v-model="form.status">
                <el-radio label="0">正常</el-radio>
                <el-radio label="1">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="yl-button" @click="submitForm">确 定</el-button>
        <el-button @click="cancel" class="yl-button2">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 修改部门序列号 -->
    <el-dialog title="修改部门序列号" :visible.sync="editDeptJurisdiction" @close="close" width="70%" append-to-body> 
      <!-- <el-form :model="editForm" label-width=".6rem">
        <el-row>
          <el-col :span="20">
            <el-form-item label="序列号">
              <el-select v-model="editForm.list" multiple style="width:2rem" placeholder="请选择">
                <el-option
                  v-for="(item,index) in serialNumberList"
                  :key="index"
                  :label="item.serial_number"
                  :value="item.serial_number"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="yl-button" @click="submitEdit">确 定</el-button>
        <el-button @click="cancelEdit" class="yl-button2">取 消</el-button>
      </div> -->
      <div class="list_index">
        <div class="operation">
          <div class="left">
            <el-radio-group v-model="status" size="small">
              <el-radio-button label="0">{{$t('GatewayName')}}</el-radio-button><!--网关名称-->
              <el-radio-button label="1">{{$t('serialNumber')}}</el-radio-button><!--序列号-->
            </el-radio-group>
            <el-input v-model="switchValue" size="small" :placeholder="status == '0' ? $t('PleaseinputGatewayName') : '请输入序列号'" class="input">
              <i slot="prefix" class="el-input__icon el-icon-ss" @click="swich()"></i>
            </el-input>
            <el-button type="primary" class="yl-button" @click="swich()">搜索</el-button>
          </div>
          <div class="right">
            <el-button type="primary" class="ml0 yl-button" @click="submitEdit">确定</el-button>
          </div>
        </div>
        <el-table stripe border ref="multipleTable" height="64vh" :data="serialNumberList" @selection-change="handleSelectionChange">
          <el-table-column  type="selection"></el-table-column>
          <el-table-column label="设备编号" prop="geteway_name"></el-table-column>
          <el-table-column label="mqtt网关序列号" align="center" prop="serial_number"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 序列号展示 -->
    <el-dialog title="序列号" :visible.sync="openSerialNumber" width="70%" append-to-body>
      <div class="list_index">
        <el-table stripe border height="64vh" :data="serialNumber">
          <el-table-column label="设备编号" prop="getewayName"></el-table-column>
          <el-table-column label="mqtt网关序列号" align="center" prop="serialnumber"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DataService from '@/api/data'
export default {
  name: "Dept",
  data() {
    return {
      status:'0',
      switchValue:'',
      serialNumberList:[],
      openSerialNumber:false,
      //序列号
      serialNumber:[],
      //序列号数组
      list:[],
      editDeptJurisdiction:false,
      // 遮罩层
      loading: false,
      // 显示搜索条件
      showSearch: true,
      // 表格树数据
      deptList: [],
      // 部门树选项
      deptOptions: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 状态数据字典
      statusOptions: [],
      //部门id
      deptId:'',
      //修改部门权限表单参数
      editForm:{
        list:[],
        user_id:this.$store.state.user_id,
        dept_id:'',
        deptName:''
      },
      // 表单参数
      form: {
        orderNum: undefined,
        status: "0",
        parentName:undefined,
        deptName:undefined
      },
      // 表单校验
      rules: {
        deptName: [
          { required: true, message: "部门名称不能为空", trigger: "blur" }
        ],
        orderNum: [
          { required: true, message: "显示排序不能为空", trigger: "blur" }
        ],
        email: [
          {
            type: "email",
            message: "'请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ],
        phone: [
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    this.getList();
    this.getSerialNumberList()
  },
  methods: {
    //关闭选择序列号弹窗
    close(){
      setTimeout(() => {
        this.$refs.multipleTable.clearSelection();
      }, 100);
    },
    //选择序列号改变
    handleSelectionChange(val){
      if(val && val != undefined){
        this.editForm.list = []
        val.forEach(el=>{
          this.editForm.list.push({
            getewayName:el.geteway_name,
            serialNumber:el.serial_number
          })
        })
      }
    },
    //根据项目现场名称和序列号查询
    swich(){
      DataService.getProjectsiteData({
        page:1,
        size:10000,
        status:this.status,
        online_status:2,
        user_id:this.$store.state.user_id,
        getewayNameOrSerialNumber:this.switchValue
      }).then(res=>{
        this.serialNumberList = res.data.projectSiteList;
      }).catch(err=>{
        this.$message.error(err.msaage)
      })
    },
    //查看序列号
    showSerialNumber(val){
      this.openSerialNumber = true;
      DataService.getDeptJurisdiction({
        dept_id:val.deptId
      }).then(res=>{
        this.serialNumber = res.data[Object.keys(res.data)[0]];
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    //修改部门权限
    async deitSerialNumberJurisdiction(val){
      let _this = this;
      this.editForm.list = []
      this.editForm.dept_id = val.deptId;
      const res = await DataService.getDeptJurisdiction({
        dept_id:val.deptId
      })
      if(res.data != ''){
        res.data[Object.keys(res.data)[0]].forEach(el => {
          this.editForm.list.push(el.serialnumber)
        });
      }
      this.editForm.list.forEach(el=>{
        this.serialNumberList.forEach(ele=>{
          if(el == ele.serial_number){
            setTimeout(()=>{
              _this.$refs.multipleTable.toggleRowSelection(ele)
            },100)
          }
        })
      })
      this.editForm.deptName = val.deptName;
      this.editDeptJurisdiction = true;
    },
    //提交修改
    submitEdit(){
      DataService.editDeptJurisdiction({
        ...this.editForm
      }).then(res=>{
        this.$message.success('操作成功')
        this.editDeptJurisdiction = false;
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    /** 查询序列号列表 **/ 
    getSerialNumberList(){
      DataService.projectsiteData({
        user_id:this.$store.state.user_id,
        status:2,
        page:1,
        size:1000
      }).then(res=>{
        this.serialNumberList = res.data.projectSiteList;
      }).catch(err=>{
        this.$message.error(err.msaage)
      })
    },
    //关闭弹窗的回调
    closeDialog(){
      this.reset()
    },
    /** 查询部门列表 */
    getList() {
      // this.loading = true;
      DataService.getDeptInfo({
        user_id:this.$store.state.user_id
      }).then(res=>{
        this.deptList = res.data;
      }).catch(err=>{
        this.$message.error(err.message)
      })
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    cancelEdit(){
      this.editDeptJurisdiction = false;
    },
    // 表单重置
    reset() {
      this.form = {
        orderNum: undefined,
        status: "0",
        parentName:undefined,
        deptName:undefined
      };
      this.resetForm("form");
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      // this.reset();
      this.open = true;
      this.title = "添加部门";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      this.deptId = row.deptId;
       this.form = {
        orderNum: row.orderNum,
        status: row.status,
        parentName:row.parentName,
        deptName:row.deptName
      };
      this.open = true;
      this.title = "修改部门";
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if(this.title == '添加部门'){
            DataService.addDept({
                ...this.form,
                createBy:this.$store.state.user_id,
                updateBy:this.$store.state.user_id,
              }).then(res=>{
              this.$message.success('新增成功')
              this.open = false;
              this.getList();
            }).catch(err=>{
              this.$message.error(err.message)
            })
          }else{
            DataService.updataDept({
                ...this.form,
                deptId:this.deptId,
                create_by:this.$store.state.user_id
              }).then(res=>{
              this.$message.success('修改成功')
              this.open = false;
              this.getList();
            }).catch(err=>{
              this.$message.error(err.message)
            })
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      let _this = this;
      this.$confirm('是否确认删除名称为"' + row.deptName + '"的数据项?', "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(function() {
          DataService.deleteDept({
            dept_id:row.deptId,
            user_id:_this.$store.state.user_id
          }).then(res=>{
             _this.$message.success("删除成功");
             _this.getList()
          }).catch(err=>{
            _this.$message.error(err.message)
          })
        })
    }
  }
};
</script>
<style lang="scss" scoped>
.list_index{
  padding: 0;
  .item{
    margin-left: 15px;
    margin-right: 15px;
  }
}
.parentName{
  width: 540px;
}
.input{
  width:258px;
  position: absolute;
}
.operation{
  display: flex;
  justify-content: space-between;
  .left{
    width: 1000px;
    /deep/ .el-radio-button:last-child .el-radio-button__inner{
      border-radius: 0;
    }
    /deep/ .el-input__inner{
      border-radius: 0 4px 4px 0;
      height: 44px;
      border: 1px solid rgba(128, 197, 255, 0.4);;
      border-left:none ;
      background: linear-gradient(0deg, rgba(98, 115, 165, 0.2), rgba(0, 174, 255, 0));
      color: #fff;
      font-size: 18px;
      padding-left: 58px;
    }
    .yl-button{
      margin-left: 270px;
    }
  }
}
</style>